export interface ExperienceItem {
  id: number;
  company: string;
  role: string;
  date: string;
  bullets: string[];
}

export const ExperienceList: ExperienceItem[] = [
  {
    id: 0,
    company: "Noham Games",
    role: "Senior Gameplay Engineer",
    date: "Aug 2024 – Dec 2025",
    bullets: [
      "Designed and implemented multiplayer architecture in Unreal Engine supporting up to 16 concurrent players.",
      "Solved complex synchronization and replication challenges in the shared economy system.",
      "Applied agile development methodologies to balance chaotic gameplay loops with stable simulation systems.",
    ],
  },
  {
    id: 1,
    company: "Arpentor Studio",
    role: "Senior Gameplay Engineer",
    date: "Feb 2023 – Jul 2024",
    bullets: [
      "Architected the core hex-grid city building framework in Unity with spatial positioning and dynamic layout systems.",
      "Designed and integrated deckbuilding mechanics including card acquisition, optimization, and synergy calculations.",
      "Owned data-driven balancing and optimization of progression systems using playtest telemetry.",
    ],
  },
  {
    id: 2,
    company: "RudeFrog Studios",
    role: "Gameplay Engineer",
    date: "Nov 2021 – Dec 2022",
    bullets: [
      "Designed and implemented core co-op survival systems in Unreal Engine 5 including wave-based spawning and weapon progression.",
      "Tackled networking replication challenges to deliver stable 4-player PvE co-op survival experiences.",
    ],
  },
  {
    id: 3,
    company: "Team6 Game Studios",
    role: "Gameplay Engineer",
    date: "Feb 2021 – Oct 2021",
    bullets: [
      "Implemented arcade-style vehicle physics and responsive driving controls in Unreal Engine.",
      "Designed dynamic passenger systems including behavior states and time-pressure delivery mechanics.",
    ],
  },
  {
    id: 4,
    company: "Dionic Software",
    role: "Gameplay Engineer",
    date: "Sep 2019 – Dec 2020",
    bullets: [
      "Built modular colonist simulation systems in Unity with personality traits, mood mechanics, and behavior modifiers.",
      "Designed modular architecture for villager decision-making, diplomacy, and resource management loops.",
    ],
  },
  {
    id: 5,
    company: "Home Net Games",
    role: "Gameplay Engineer",
    date: "Aug 2018 – Sep 2019",
    bullets: [
      "Designed flight control systems and physics-based aircraft handling for WW1 planes in Unity.",
      "Implemented FSM-driven behavior systems for aircraft flight states and enemy decision logic.",
    ],
  },
  {
    id: 6,
    company: "Heartbeast",
    role: "Junior Gameplay Engineer",
    date: "Aug 2017 – Jun 2018",
    bullets: [
      "Developed turn-based roguelike gameplay with procedural hallway generation and grid-based enemy behavior in Godot.",
    ],
  },
  {
    id: 7,
    company: "Casualogic",
    role: "Junior Gameplay Engineer",
    date: "Feb 2016 – Jul 2017",
    bullets: [
      "Implemented crew management and simulation systems in Godot for a space station management sim.",
    ],
  },
];
